.GenericEmptyState {
  display: flex;
  gap: 30px;
  justify-content: center;
  padding: 32px 0;
  grid-column: 1/4;

  &-content {
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
    width: 458px;
    padding-top: 10px;

    p {
      color: var(--color_neutral_800, #4c5567);
      font-size: 14px;
    }
  }
}
